import { render, staticRenderFns } from "./SimplePatientViewer.vue?vue&type=template&id=fadfc030&scoped=true&"
import script from "./SimplePatientViewer.vue?vue&type=script&lang=ts&"
export * from "./SimplePatientViewer.vue?vue&type=script&lang=ts&"
import style0 from "./SimplePatientViewer.vue?vue&type=style&index=0&id=fadfc030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadfc030",
  null
  
)

export default component.exports